let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("04dfq")).then(() => parcelRequire('b9sjx'));